import { database } from '../config';
import firebase from 'firebase/app';
import { detectDeviceType } from './detectNavigator';

export default class Error {

    guardarError(error) {
        try{
            firebase.auth().onAuthStateChanged(user => {

                const err = {
                    codigo: error.code,
                    error: error.message,
                    fecha: new Date(),
                    dispositivo: detectDeviceType(),
                    usuario: user ? user.email : ''
                }
    
                database.collection("errores")
                .doc()
                .set(err)
                .then()
                .catch(error => console.error(error))
            })
        }catch{

        }finally{
            return error
        }
    }

}